import { Link, useLocation } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const { pathname } = useLocation();
  const isSpanish = pathname.startsWith('/apply/es');

  const legalText = isSpanish
    ? 'Lantern Prep Inc. es una organización sin fines de lucro reconocida bajo la sección 501(c)(3). EIN: 41-5293031. Las contribuciones son deducibles de impuestos en la medida permitida por la ley.'
    : 'Lantern Prep Inc. is a recognized 501(c)(3) nonprofit organization. EIN: 41-5293031. Contributions are tax-deductible to the extent allowed by law.';

  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="-mt-4 mb-3">
              <Logo />
            </div>
            <p className="text-primary-foreground/70 leading-relaxed max-w-md text-sm">
              Considered preparation for the SAT, college admissions, and the years that follow. A selective practice serving the greater Tampa Bay area.
            </p>
            <p className="text-primary-foreground/55 leading-relaxed max-w-md text-xs mt-4">
              {legalText}
            </p>
          </div>

          {/* Practice */}
          <div>
            <h4 className="text-xs font-medium tracking-[0.2em] uppercase text-accent mb-5">
              Practice
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-primary-foreground/75 hover:text-accent transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/programs" className="text-primary-foreground/75 hover:text-accent transition-colors">
                  Programs
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-primary-foreground/75 hover:text-accent transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/scholarship-model" className="text-primary-foreground/75 hover:text-accent transition-colors">
                  Scholarship Model
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-medium tracking-[0.2em] uppercase text-accent mb-5">
              Contact
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start">
                <MapPin size={16} className="mr-2 mt-0.5 text-accent flex-shrink-0" />
                <span className="text-primary-foreground/75">St. Petersburg, FL</span>
              </li>
              <li className="flex items-start">
                <Mail size={16} className="mr-2 mt-0.5 text-accent flex-shrink-0" />
                <a
                  href="mailto:andrea@lanternprep.org"
                  className="text-primary-foreground/75 hover:text-accent transition-colors"
                >
                  andrea@lanternprep.org
                </a>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="inline-block mt-2 text-accent border-b border-accent/40 pb-1 hover:border-accent transition-colors"
                >
                  Request Consultation
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/15 mt-16 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0">
            <p className="text-primary-foreground/50 text-xs">
              © {new Date().getFullYear()} Lantern Prep. All rights reserved.
            </p>
            <div className="flex space-x-6 text-xs">
              <Link to="/scholarship-model" className="text-primary-foreground/50 hover:text-accent transition-colors">
                Scholarship Model
              </Link>
            </div>
          </div>
          <p className="text-primary-foreground/40 text-xs leading-relaxed mt-6 max-w-3xl">
            Nothing on this site constitutes legal advice or creates an attorney–client relationship.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
